import * as z from "zod";
import {
  creatorGrantPrincipal,
  creatorUserId,
  defaultCreatorGrants,
} from "../rbac/roles";
import { insertGrantsDeduped } from "../rbac/validation";
import { mutator } from "./mutator";

export const createServiceAccountSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
});

// Creating a service account is tenant-gated. The creator is granted manage
// rights on the new account so they can immediately issue credentials and
// assign grants; this self-grant is what lets a non-admin creator administer
// the account they just made.
export const createServiceAccount = mutator({
  schema: createServiceAccountSchema,
  resolve: {},
  permissions: [
    {
      permission: "tenant:service_account_create",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args: { id, name, description } }) => {
    const now = Date.now();
    await tx.mutate.serviceAccounts.insert({
      id,
      name,
      description: description ?? null,
      disabled: false,
      createdByUserId: creatorUserId(ctx),
      createdAt: now,
      updatedAt: now,
      tenantId: ctx.tenantId,
    });

    await insertGrantsDeduped(
      tx,
      defaultCreatorGrants("service_account", creatorGrantPrincipal(ctx)),
      id,
      ctx.tenantId
    );
  },
});
